export const OrbsBackground = ({
  src,
  setVideoLoadFailed,
}: {
  src: string;
  setVideoLoadFailed: (value: boolean) => void;
}) => (
  <video className="orbs-video" autoPlay loop muted playsInline id="orbs-video">
    <source src={src} type="video/mp4" onError={() => setVideoLoadFailed(true)} />
  </video>
);
